/**
 * @generated SignedSource<<176a9f1b9b9406abd04aff09e1625c5d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type LearningSortEnum = "CREATION_DATE_ASC" | "CREATION_DATE_DESC" | "ID_ASC" | "ID_DESC" | "SUMMARY_ASC" | "SUMMARY_DESC";
export type LearningType = "DECISION" | "LEARNING" | "RISK";
export type TrackViewEvent = "DIRECT" | "INDIRECT" | "SKIP";
export type ProjectLearningsTabQuery$variables = {
  key: string;
  learningsSort?: ReadonlyArray<LearningSortEnum | null> | null;
  tagCount?: number | null;
  trackViewEvent?: TrackViewEvent | null;
  type?: LearningType | null;
};
export type ProjectLearningsTabQuery$data = {
  readonly project: {
    readonly id: string;
    readonly learnings: {
      readonly __id: string;
      readonly count: number;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        } | null;
      } | null> | null;
    } | null;
    readonly state: {
      readonly label: string | null;
    } | null;
    readonly tags: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly watcherCount: number;
        } | null;
      } | null> | null;
    } | null;
    readonly uuid: string;
    readonly watchers: {
      readonly count: number;
    } | null;
    readonly workspace: {
      readonly uuid: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"LearningsList" | "NewLearningsPanel" | "RelatedLearnings">;
  } | null;
};
export type ProjectLearningsTabQuery = {
  response: ProjectLearningsTabQuery$data;
  variables: ProjectLearningsTabQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "learningsSort"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagCount"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trackViewEvent"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v5 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "key"
  },
  {
    "kind": "Variable",
    "name": "trackViewEvent",
    "variableName": "trackViewEvent"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v8 = [
  {
    "kind": "ScalarField",
    "name": "label"
  }
],
v9 = {
  "concreteType": "ProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v8/*: any*/)
},
v10 = {
  "kind": "Variable",
  "name": "sort",
  "variableName": "learningsSort"
},
v11 = {
  "kind": "Variable",
  "name": "type",
  "variableName": "type"
},
v12 = [
  (v10/*: any*/),
  (v11/*: any*/)
],
v13 = {
  "kind": "ScalarField",
  "name": "count"
},
v14 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v15 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v16 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v17 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v18 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "tagCount"
  }
],
v19 = {
  "kind": "ScalarField",
  "name": "watcherCount"
},
v20 = {
  "concreteType": "UserConnection",
  "kind": "LinkedField",
  "name": "watchers",
  "plural": false,
  "selections": [
    (v13/*: any*/)
  ]
},
v21 = {
  "kind": "Variable",
  "name": "tagCount",
  "variableName": "tagCount"
},
v22 = {
  "concreteType": "Workspace",
  "kind": "LinkedField",
  "name": "workspace",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    (v6/*: any*/)
  ]
},
v23 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200
  },
  (v10/*: any*/),
  (v11/*: any*/)
],
v24 = {
  "kind": "ScalarField",
  "name": "summary"
},
v25 = {
  "kind": "ScalarField",
  "name": "ari"
},
v26 = {
  "kind": "ScalarField",
  "name": "key"
},
v27 = {
  "kind": "ScalarField",
  "name": "name"
},
v28 = [
  {
    "concreteType": "UserPII",
    "kind": "LinkedField",
    "name": "pii",
    "plural": false,
    "selections": [
      (v27/*: any*/),
      {
        "kind": "ScalarField",
        "name": "picture"
      }
    ]
  },
  {
    "kind": "ScalarField",
    "name": "aaid"
  },
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectLearningsTabQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v5/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v6/*: any*/),
            "action": "LOG",
            "path": "project.id"
          },
          (v7/*: any*/),
          (v9/*: any*/),
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "Workspace",
              "kind": "LinkedField",
              "name": "workspace",
              "plural": false,
              "selections": [
                (v7/*: any*/)
              ]
            },
            "action": "LOG",
            "path": "project.workspace"
          },
          {
            "alias": "learnings",
            "args": (v12/*: any*/),
            "concreteType": "LearningConnection",
            "kind": "LinkedField",
            "name": "__LearningsList__learnings_connection",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "concreteType": "LearningEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Learning",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v14/*: any*/)
                    ]
                  },
                  (v15/*: any*/)
                ]
              },
              (v16/*: any*/),
              (v17/*: any*/)
            ]
          },
          {
            "args": (v18/*: any*/),
            "concreteType": "TagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Tag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v19/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v20/*: any*/),
          {
            "args": [
              (v10/*: any*/),
              (v21/*: any*/),
              (v11/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "LearningsList"
          },
          {
            "args": (v12/*: any*/),
            "kind": "FragmentSpread",
            "name": "RelatedLearnings"
          },
          {
            "args": [
              (v21/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "NewLearningsPanel"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectLearningsTabQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v5/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v9/*: any*/),
          (v22/*: any*/),
          {
            "args": (v23/*: any*/),
            "concreteType": "LearningConnection",
            "kind": "LinkedField",
            "name": "learnings",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "concreteType": "LearningEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Learning",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v14/*: any*/),
                      (v7/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "type"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v24/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "description"
                          },
                          (v25/*: any*/),
                          {
                            "concreteType": "Project",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v7/*: any*/),
                              (v25/*: any*/),
                              (v22/*: any*/),
                              (v9/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "Goal",
                            "kind": "LinkedField",
                            "name": "goal",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v7/*: any*/),
                              (v25/*: any*/),
                              (v22/*: any*/),
                              {
                                "concreteType": "GoalState",
                                "kind": "LinkedField",
                                "name": "state",
                                "plural": false,
                                "selections": (v8/*: any*/)
                              }
                            ]
                          },
                          {
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": (v28/*: any*/)
                          },
                          {
                            "kind": "ScalarField",
                            "name": "creationDate"
                          },
                          {
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "lastEditedBy",
                            "plural": false,
                            "selections": (v28/*: any*/)
                          },
                          {
                            "kind": "ScalarField",
                            "name": "lastEditedDate"
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isRecentlyAdded"
                              }
                            ]
                          }
                        ],
                        "type": "Highlight",
                        "abstractKey": "__isHighlight"
                      }
                    ]
                  },
                  (v15/*: any*/)
                ]
              },
              (v16/*: any*/),
              (v17/*: any*/)
            ]
          },
          {
            "args": (v23/*: any*/),
            "filters": [
              "sort",
              "type"
            ],
            "handle": "connection",
            "key": "LearningsList__learnings",
            "kind": "LinkedHandle",
            "name": "learnings"
          },
          {
            "args": (v18/*: any*/),
            "concreteType": "TagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Tag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v19/*: any*/),
                      (v27/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v20/*: any*/),
          (v19/*: any*/),
          {
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 6
              },
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "concreteType": "LearningConnection",
            "kind": "LinkedField",
            "name": "relatedLearnings",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "concreteType": "LearningEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Learning",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v24/*: any*/),
                      {
                        "concreteType": "Project",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v27/*: any*/),
                          (v26/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "19992b5079de33df81f28d1db23c4266",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "project",
            "learnings"
          ]
        }
      ]
    },
    "name": "ProjectLearningsTabQuery",
    "operationKind": "query",
    "text": "query ProjectLearningsTabQuery(\n  $key: String!\n  $trackViewEvent: TrackViewEvent\n  $learningsSort: [LearningSortEnum]\n  $tagCount: Int\n  $type: LearningType\n) {\n  project: projectByKey(key: $key, trackViewEvent: $trackViewEvent) {\n    id\n    uuid\n    state {\n      label\n    }\n    workspace {\n      uuid\n      id\n    }\n    learnings(sort: $learningsSort, first: 200, type: $type) {\n      count\n      edges {\n        node {\n          id\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    tags(first: $tagCount) {\n      edges {\n        node {\n          id\n          watcherCount\n        }\n      }\n    }\n    watchers {\n      count\n    }\n    ...LearningsList_2M1Xv6\n    ...RelatedLearnings_s5dLK\n    ...NewLearningsPanel_2MWLOs\n  }\n}\n\nfragment LearningModifierSignatures_data on Highlight {\n  __isHighlight: __typename\n  uuid\n  ari\n  project {\n    key\n    ari\n    id\n  }\n  goal {\n    key\n    ari\n    id\n  }\n  creator {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  creationDate\n  lastEditedBy {\n    pii {\n      name\n    }\n    ...UserAvatar_2aqwkz\n    id\n  }\n  lastEditedDate\n}\n\nfragment LearningTags_data on TagConnection {\n  edges {\n    node {\n      id\n      name\n      watcherCount\n    }\n  }\n}\n\nfragment Learning_data on Highlight {\n  __isHighlight: __typename\n  __typename\n  id\n  summary\n  description\n  uuid\n  ari\n  project {\n    id\n    key\n    name\n    uuid\n    ari\n    workspace {\n      uuid\n      id\n    }\n    state {\n      label\n    }\n  }\n  goal {\n    id\n    key\n    name\n    uuid\n    ari\n    workspace {\n      uuid\n      id\n    }\n    state {\n      label\n    }\n  }\n  ...LearningModifierSignatures_data\n}\n\nfragment LearningsList_2M1Xv6 on Project {\n  learnings(sort: $learningsSort, first: 200, type: $type) {\n    count\n    edges {\n      node {\n        id\n        uuid\n        type\n        ... on Highlight {\n          __isHighlight: __typename\n          ...Learning_data\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  watcherCount\n  tags(first: $tagCount) {\n    ...LearningTags_data\n  }\n}\n\nfragment NewLearningsPanel_2MWLOs on Project {\n  watcherCount\n  tags(first: $tagCount) {\n    edges {\n      node {\n        watcherCount\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment RelatedLearning on Learning {\n  uuid\n  summary\n  project {\n    id\n    name\n    key\n  }\n}\n\nfragment RelatedLearnings_s5dLK on Project {\n  relatedLearnings(sort: $learningsSort, first: 6, type: $type) {\n    count\n    edges {\n      node {\n        id\n        ...RelatedLearning\n      }\n    }\n  }\n}\n\nfragment UserAvatar_2aqwkz on User {\n  aaid\n  pii {\n    picture\n  }\n}\n"
  }
};
})();

(node as any).hash = "80e359cdea30b51bf90e8064109fe918";

export default node;
